import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { PureBiData } from '@wix/da-bi/pkg/events';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeToUnlockTooltip from '../../_partials/SubscribeToUnlockTooltip';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import { getDeviationFreeDownload } from './permissions';
const logger = ddt.createLogger('downloadbutton');
const FreeDownloadButton = ({ deviation, className, onDownload, onMouseEnter, onMouseLeave })=>{
    const { t } = useTranslation();
    const { isLoggedIn, restrictToLoggedIn } = useRestrictToLoggedIn();
    // when the user first purchases a subscription, open the tooltip and highlight the icon
    const isButtonHighlighted = useContext(SubscriptionPurchaseFTUEContext) === 'tooltips';
    logger.log('FreeDownloadButton, deviation:', deviation);
    const { download, permission } = getDeviationFreeDownload(deviation);
    logger.log({
        download,
        permission
    });
    if (!download) {
        return null;
    }
    const wrapperProps = {
        className: className,
        forceVisibleTooltip: isButtonHighlighted
    };
    const buttonProps = {
        biData: PureBiData({
            evid: 350,
            ispaiddownload: 0,
            deviationid: deviation.deviationId,
            sectionname: 'action_bar'
        }),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    // send anon to sisu for both free and premium downloads
    if (!isLoggedIn) {
        const tooltip = t('actionbar.download.mustLogIn');
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, _object_spread_props(_object_spread({}, wrapperProps), {
            tooltip: tooltip
        }), /*#__PURE__*/ React.createElement(ActionBarButton, _object_spread_props(_object_spread({}, buttonProps), {
            "aria-label": tooltip,
            onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD)
        }), /*#__PURE__*/ React.createElement(ActionBarIcon, {
            isActive: isButtonHighlighted,
            icon: DownloadIcon
        })));
    }
    // in-tier, un-subbed free downloads are blocked with a special popup
    const subPreventsDownload = permission === 'needs_subscription' || permission === 'blocked_by_subscription';
    if (subPreventsDownload) {
        logger.log('free download blocked by tier', deviation.tier);
        return /*#__PURE__*/ React.createElement(SubscribeToUnlockTooltip, {
            className: className,
            deviation: deviation,
            forceVisible: isButtonHighlighted
        }, /*#__PURE__*/ React.createElement(ActionBarButton, _object_spread_props(_object_spread({}, buttonProps), {
            disabled: true,
            "aria-label": t('actionbar.freeDownload')
        }), /*#__PURE__*/ React.createElement(ActionBarIcon, {
            isActive: isButtonHighlighted,
            icon: DownloadIcon
        })));
    }
    // here, we know the user is logged in and the special case of
    // free downloads in subscription content is handled, so let them download
    const tooltip = t('actionbar.freeDownload');
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, _object_spread_props(_object_spread({}, wrapperProps), {
        tooltip: tooltip
    }), /*#__PURE__*/ React.createElement(ActionBarButton, _object_spread_props(_object_spread({}, buttonProps), {
        href: download.url,
        target: "_blank",
        download: true,
        "aria-label": tooltip,
        onClick: download.url ? onDownload : undefined
    }), /*#__PURE__*/ React.createElement(ActionBarIcon, {
        isActive: isButtonHighlighted,
        icon: DownloadIcon
    })));
};
FreeDownloadButton.displayName = 'FreeDownloadButton';
export default FreeDownloadButton;
